// import { Box, Button, InputAdornment, TextField, Typography } from "@mui/material";
// import { COLOR } from "../../../../utils/colors";
// import { AddOutlined } from "@mui/icons-material";
// import { VIEW } from "../../../../utils/breakpoint";
// import { useState } from "react";
// import { GridSearchIcon } from "@mui/x-data-grid";
// import ListRobotTable from "../../robot/list-robot-table";
// import { RobotType } from "../../../../hooks/robot/index.type";

import { useState } from "react"
import { RobotType } from "../../../hooks/robot/index.type"
import { Box, Button, InputAdornment, TextField, Typography } from "@mui/material"
import { COLOR } from "../../../utils/colors"
import { VIEW } from "../../../utils/breakpoint"
import { AddOutlined } from "@mui/icons-material"
import { GridSearchIcon } from "@mui/x-data-grid"
import ListRobotTable from "./list-robot-table"
import { useNavigate } from "react-router-dom"

export default function ListRobotPage({
  onHandleEdit,
  onSubmitRobot,
  defaultSelectedRobots
}: {
  onHandleEdit?: (robotId: string) => void
  onSubmitRobot?: (robots: RobotType[]) => void,
  defaultSelectedRobots?: RobotType[]
}) {
  const navigate = useNavigate()
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedRobots, setSelectedRobots] = useState<RobotType[]>(defaultSelectedRobots || [])

  const isDisableNext = selectedRobots.length === 0;

  const onHandleUpdateSelectedRobot = (robots: RobotType[]) => {
    setSelectedRobots(robots)
  }

  const onCreateNew = () => {
    navigate('/config/robots/create')
  }

  const onHandleNext = () => {
   if (selectedRobots.length <= 0) {
    return
   }
   onSubmitRobot?.(selectedRobots)
  }
  return (
    <Box sx={(theme) => ({
      paddingY: '34px',
      color: COLOR.neutral[900],
      [theme.breakpoints.up(VIEW.PHONE)]: {
        paddingX: '24px',
      },
      [theme.breakpoints.up(VIEW.TABLET)]: {
        paddingX: '44px',
      }
    })}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography
            sx={{
              fontSize: '24px',
              fontWeight: 600,
              color: COLOR.neutral[900]
            }}
          >
            Robot
          </Typography>
          <Button onClick={() => onCreateNew?.()} variant="outlined" startIcon={<AddOutlined />}>
            Create New
          </Button>
        </Box>
        <Box sx={{ display: 'flex', mt: '20px' }}>
          <TextField
            id="search-store-name"
            variant="outlined"
            size="small"
            placeholder='Search Robot'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              flex: 'auto',
              backgroundColor: 'white',
              height: "40px",
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <GridSearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>
      <ListRobotTable 
        defaultSelectedRobots={selectedRobots || defaultSelectedRobots || []}
        search={searchTerm}
        onSelectedChange={(robots) => onHandleUpdateSelectedRobot(robots)}
        onEditRobot={(robot) => navigate('/config/robots/' + robot.robot_mac + '/edit')}
      />
    </Box>
  )
}